export const ITEM_HEIGHT = 36;
export const ITEM_GAP = 0;
export const MID_HEIGHT = 36;

export const SIDE_DISPLAY_COUNT = 4;
export const SIDE_DISPLAY_HEIGHT = SIDE_DISPLAY_COUNT * (ITEM_HEIGHT + ITEM_GAP);
